import Container from "../../components/Container";

export default function NotFound() {
  return <Container linkBack={"/"} titulo={"Página no encontrada"}></Container>;
}
